import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_4 = { class: "text-neutral-600" }
const _hoisted_5 = {
  class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
  style: {"max-width":"700px"}
}
const _hoisted_6 = { class: "__section__content" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " Ngày tháng năm sinh của trẻ ", -1)
const _hoisted_10 = {
  key: 0,
  class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10"
}
const _hoisted_11 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_12 = { class: "text-neutral-600" }
const _hoisted_13 = {
  class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
  style: {"max-width":"700px"}
}
const _hoisted_14 = { class: "__section__content" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label uppercase text-neutral-400 text-xs font-semibold" }, " can thiệp cá nhân ", -1)
const _hoisted_18 = {
  key: 0,
  class: "input-group flex-nowrap flex items-center justify-between p-6"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label uppercase text-neutral-400 text-xs font-semibold" }, " Lớp bán trú ", -1)
const _hoisted_20 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10" }
const _hoisted_21 = { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }
const _hoisted_22 = { class: "text-neutral-600" }
const _hoisted_23 = {
  class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
  style: {"max-width":"700px"}
}
const _hoisted_24 = { class: "__section__content" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_27 = { class: "input-group__label uppercase text-neutral-400 text-xs font-semibold" }
const _hoisted_28 = {
  key: 1,
  class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden mt-10"
}
const _hoisted_29 = { class: "__section__header font-semibold text-neutral-400 p-6 border-b" }
const _hoisted_30 = { class: "relative text-neutral-600 flex items-center gap-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15.4041 8.49733L17.1377 6.76375L17.1377 6.76374L17.1377 6.76372C17.6368 6.26463 17.8863 6.01508 18.0269 5.74991C18.3376 5.164 18.3376 4.46221 18.0269 3.8763C17.8863 3.61112 17.6368 3.36156 17.1377 2.86246C16.6386 2.36335 16.389 2.11379 16.1238 1.97321C15.5379 1.66258 14.8361 1.66258 14.2502 1.97321C13.985 2.11379 13.7355 2.36335 13.2364 2.86246L11.4807 4.61818C12.4198 6.22874 13.772 7.57058 15.4041 8.49733ZM10.0262 6.07265L3.36419 12.7346C2.93913 13.1597 2.7266 13.3722 2.58687 13.6333C2.44713 13.8944 2.38819 14.1891 2.27029 14.7786L1.67957 17.7322C1.61305 18.0648 1.57979 18.2311 1.6744 18.3257C1.76901 18.4203 1.93531 18.3871 2.26792 18.3206L5.22152 17.7298C5.81098 17.6119 6.1057 17.553 6.3668 17.4133C6.6279 17.2735 6.84043 17.061 7.26549 16.6359L13.9459 9.95556C12.3647 8.96432 11.027 7.63576 10.0262 6.07265Z",
    fill: "#94A3B8"
  })
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "text-neutral-500 font-normal leading-5 text-sm mt-2" }
const _hoisted_34 = { class: "__section__content" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_37 = { class: "input-group__label text-neutral-400 font-semibold uppercase text-xs w-full" }
const _hoisted_38 = {
  key: 0,
  class: "__section__header font-semibold text-neutral-600 py-6 px-6 border-b"
}
const _hoisted_39 = { class: "font-semibold text-neutral-600 mb-4" }
const _hoisted_40 = { class: "flex flex-col gap-3" }
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_44 = { class: "ml-4 text-green-600 font-semibold whitespace-pre-wrap w-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, "Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " xem thông tin", 1),
        _createElementVNode("div", _hoisted_5, " Ở trạng thái bật, " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " xem được thông tin sau ", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_show_dob_of_student_for_staff,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enable_show_dob_of_student_for_staff) = $event))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ]),
    (!_ctx.isLitePackage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, " Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " gửi thông báo điểm danh tới Phụ huynh ", 1),
            _createElementVNode("div", _hoisted_13, " Ở trạng thái bật, cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " gửi thông báo điểm danh tới Phụ huynh. Ở trạng thái tắt, chỉ có cấp Quản lý được quyền gửi thông báo này. ", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_SwitchButton, {
                  value: _ctx.enable_staff_send_attendance_track,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enable_staff_send_attendance_track) = $event))
                }, null, 8, ["value"])
              ]),
              (_ctx.flagCheck())
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_SwitchButton, {
                      value: 
								_ctx.enable_staff_send_day_care_attendance_track
							,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((
								_ctx.enable_staff_send_day_care_attendance_track
							) = $event))
                    }, null, 8, ["value"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, " Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " xem tất cả " + _toDisplayString(_ctx.$filters.terminology('plan')), 1),
        _createElementVNode("div", _hoisted_23, " Ở trạng thái bật, " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " có thể xem " + _toDisplayString(_ctx.$filters.terminology('plan')) + " của toàn bộ học sinh của trung tâm, kể cả những học sinh không trực tiếp phụ trách. ", 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, " Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " xem tất cả " + _toDisplayString(_ctx.$filters.terminology('plan')), 1),
            _createVNode(_component_SwitchButton, {
              value: 
								_ctx.enable_staff_access_all_student_plans
							,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((
								_ctx.enable_staff_access_all_student_plans
							) = $event))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ]),
    (!_ctx.isLitePackage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", null, "Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " tạo đánh giá định kỳ", 1),
              (_ctx.enable_assessment_document_creation_right)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "absolute right-0 cursor-pointer",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addTeachers && _ctx.addTeachers(...args)))
                  }, _hoisted_32))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, " Ở chế độ bật, hệ thống sẽ hiển thị danh sách " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + ". Bạn có thể chọn người phù hợp để cấp quyền tạo đánh giá định kì. ", 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, " Cho phép " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " tạo đánh giá định kỳ ", 1),
                _createVNode(_component_SwitchButton, {
                  value: 
								_ctx.enable_assessment_document_creation_right
							,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((
								_ctx.enable_assessment_document_creation_right
							) = $event))
                }, null, 8, ["value"])
              ])
            ])
          ]),
          (_ctx.teachers.length && !_ctx.isLitePackage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, " Danh sách " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " đã được cấp quyền tạo đánh giá định kì ", 1),
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachers, (person) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: person.id
                    }, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", null, [
                          (person?.profile_photo?.w200)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                src: person?.profile_photo?.w200,
                                alt: ""
                              }, null, 8, _hoisted_42))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                style: _normalizeStyle({
										background:
											person?.profile_photo?.default
												?.color,
									})
                              }, [
                                _createElementVNode("span", _hoisted_43, _toDisplayString(person?.profile_photo?.default
												?.initial), 1)
                              ], 4))
                        ]),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(person.name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}